import { Section } from '~/shared/section/Section';
import { PatientPhysicians } from '~/features/patient-physicians/PatientPhysicians';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientPhysiciansRoute() {
	const { stayId } = useChart();
	return (
		<Section header={<SectionTitle title="Physicians" />}>
			<PatientPhysicians stayId={stayId} />
		</Section>
	);
}
